import React, { Component } from 'react';
import './style.css';

class StudyList extends Component {
  constructor(props){
    super(props)

    this.state={
      showButton : false
    };
  }


  participate(data){
    this.props.editStudy(data);
  }
  createStudy(){
    this.props.createStudy();
  }

  viewInvites(data){
    this.props.viewInvites(data);
  }
  
  render() {
    let studyList="";
    let studyItem = "";
    if(this.props.studies && this.props.studies.length){
      let studies = this.props.studies;
      studyList = Object.keys(studies).map((item, index) => {
        studyItem = studies[item];
         if(studyItem.is_live == true){
          studyItem.isLive = "live";
          }else{
          studyItem.isLive = "not live";
          }

        return <tr  key={index}>
          <td>{index+1}</td>
          <td>{studyItem.study_name}</td>
          <td class="studyUrl">{studyItem.study_url}</td>
          <td >{studyItem.cpi}</td>
          <td >{studyItem.isLive}</td>
          <td >{studyItem.totalInvities}</td>
          <td><button className = "editstudybtn" type="button" onClick={this.viewInvites.bind(this, studyItem)}  > View  </button></td>
          <td><button className = "editstudybtn" type="button" onClick={this.participate.bind(this, studyItem)}  > Edit </button></td>
          </tr>
      });
    }

    return (
      <div className = "studylistpage">
      <div className = "studylistback">
        <div className = "studyheader"><h1> My Studies </h1></div>
        <div ><button  className = "createstudybtn"  onClick={this.createStudy.bind(this)}>Create study</button></div>
        <div className ="studylistscroll">
        <table className = "tablestudylists" >
        <tr >
        <th>Sr. No.</th>
        <th >Study Name</th>
        <th >Study Url</th>
        <th >Reward</th>
        <th > Status</th>
        <th > Total Invities</th>
        <th > View Invities</th>
        <th> Action</th>
        
        </tr>
        {studyList}
        </table>
        </div>
      </div>
      </div>
    );
  }
}
export default StudyList;



// WEBPACK FOOTER //
// ./src/components/study/studyList.js